import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata,
    DoppeActionTypeRenderingInPageSupport
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeHideableValue,
    doppeHideableValueGetVisibleValue,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeaturesAlias
} from '../../client-server-common';
import {WixMediaResource, wixMediaResourceReplaceExternalImage} from '@wix/devzai-common-wix';
import {asArray, hideableValueCreateHidden, immerProduce} from '@wix/devzai-utils-common';


export namespace DoppeActionTypeBanner {

    export interface ActionSettings {
        url: DoppeHideableValue<string>;
        image: WixMediaResource | null;
    }
}

export const doppeActionTypeBanner = doppeActionTypeDefineMetadata<DoppeActionTypeBanner.ActionSettings>({
    id: 'io.bymo.action/banner',
    hasNoGoalMeasuring: false,
    isLinkOpener: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            url: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl),
            image: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.SingleMedia, BymoPagePropsContentSettingSemanticMeaning.EntityMedia)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
    skipReportingOnGoalAchievedOnActionButtonClick: false,
    lockIsNotSupported: true,
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        url: hideableValueCreateHidden('Banner Link'),
        image: null,
    }),
    canRenderInPage: DoppeActionTypeRenderingInPageSupport.AsCardOnly,
    hasDisplaySettings: false,
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeaturesAlias.bannerAction)
    },
    resolveUsedMedia: actionSettings => {
        return actionSettings.image ? asArray(actionSettings.image) : [];
    },
    replaceExternalImages: (actionSettings, externalImagesUrlToImageResourceMap) => {
        return immerProduce(actionSettings, actionSettings => {
            if (actionSettings.image) {
                actionSettings.image = wixMediaResourceReplaceExternalImage(actionSettings.image, externalImagesUrlToImageResourceMap);
            }
        })
    },
    resolveMainMedia: actionSettings => {
        return actionSettings.image
    },
    resolveMainLink: actionSettings => {
        return doppeHideableValueGetVisibleValue(actionSettings.url, null)
    }
})